export default class ModalService {
	static onOpen() {
		App.state.rootStore.chatViewStore.toggleChatBox(false);
	}

	static onClose() {
		//do something
	}
}
